export default __webpack_public_path__ + "static/media/Sirvve_terms-and-conditions.db1c25ce.pdf";